import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Devices',
  components: {

  },
  props: {

  },
  emits: {
      
  },
})
export default class Devices extends Vue {
    
}
